import Vue from 'vue'
import VueRouter from 'vue-router'

import EventComponent from '@/components/EventComponent'
import ParticipantComponent from '@/components/ParticipantComponent'
import WishlistComponent from '@/components/WishlistComponent'

const routes = [
  { path: '', component: EventComponent },
  { path: '/:event', component: EventComponent,
    children: [
      { path: '', component: ParticipantComponent, name: 'code',
        children: [
          { path: 'wishlist/:participant', component: WishlistComponent, name: 'wishlist' },
        ]
      },
    ]
  }
]

Vue.use(VueRouter)
const router = new VueRouter({
  scrollBehavior (to, from, savedPosition) { return {x: 0, y: 0} },
  mode: 'history',
  routes
})

export default router
